import { Bookmark, BookmarkGroup, DateInfo } from './types';

export const formatDate = (dateString: string): DateInfo => {
  const date = new Date(dateString);
  const dateStr = date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
  const dayStr = date.toLocaleDateString('en-US', { weekday: 'long' });
  const timeStr = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
  return { dateStr, dayStr, timeStr };
};

export const getDateKey = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toDateString(); // Returns "Mon Jan 15 2024" format for grouping
};

export const groupBookmarksByDate = (bookmarks: Bookmark[]): BookmarkGroup[] => {
  const groups: { [key: string]: Bookmark[] } = {};
  
  bookmarks.forEach(bookmark => {
    const dateKey = getDateKey(bookmark.createdAt);
    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }
    groups[dateKey].push(bookmark);
  });

  // Sort groups by date (newest first) and sort bookmarks within each group by time (newest first)
  const sortedGroups = Object.entries(groups)
    .map(([dateKey, groupBookmarks]) => ({
      dateKey,
      date: new Date(dateKey),
      bookmarks: groupBookmarks.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    }))
    .sort((a, b) => b.date.getTime() - a.date.getTime());

  return sortedGroups;
};